<script>
export default {
    props: {
        embed: {
            type: String,
            default: ""
        },
    },
    methods: {
        playVideo() {
            this.$emit('play-video', this.embed);
        }
    },
}
</script>

<style>

</style>